// Alias index file of next/server for edge runtime for tree-shaking purpose
export { ImageResponse } from '../spec-extension/image-response';
export { NextRequest } from '../spec-extension/request';
export { NextResponse } from '../spec-extension/response';
export { userAgent, userAgentFromString } from '../spec-extension/user-agent';
export { URLPattern } from '../spec-extension/url-pattern';
export { unstable_after } from '../../after';
export { connection } from '../../request/connection';

//# sourceMappingURL=index.js.map